import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { IOptionsResponse } from '../../../common/common.types'
import { CrewService } from '../services/crew.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { setPreceptorStudentOptions } from '../store/crew.actions'

export function* setCrewPreceptorStudentOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const crewService = new CrewService(serviceId)
  try {
    const response: IOptionsResponse = yield call([crewService, crewService.getPreceptorStudentOptions])
    const { entity } = response
    yield put(setPreceptorStudentOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setCrewPreceptorStudentOptions() error: ${e}`))
  }
}

export function* setCrewPreceptorStudentOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setCrewPreceptorStudentOptions)
}
